module.exports = __webpack_public_path__ + "img/DE04602.6ada17ac.png";